import { createI18n } from 'vue-i18n';
import {
  DEFAULT_LOCALE,
  FALLBACK_LOCALE,
  LOCALE_STORAGE_KEY,
  SUPPORTED_LOCALES,
} from '@/config/locale.js';
import zhCN from './locales/zh-CN.json';
import enUS from './locales/en-US.json';

/** 语言包注册表：与 SUPPORTED_LOCALES 一一对应 */
const LOCALE_MESSAGES = {
  'zh-CN': zhCN,
  'en-US': enUS,
};

/** 从 localStorage 读取用户上次选择的语言 */
function readStoredLocale() {
  try {
    const stored = localStorage.getItem(LOCALE_STORAGE_KEY);
    if (stored && SUPPORTED_LOCALES.some((item) => item.value === stored)) {
      return stored;
    }
  } catch {
    /* 隐私模式等场景下 localStorage 可能不可用 */
  }
  return DEFAULT_LOCALE;
}

function applyHtmlLang(locale) {
  if (typeof document !== 'undefined') {
    document.documentElement.setAttribute('lang', locale);
  }
}

const initialLocale = readStoredLocale();
applyHtmlLang(initialLocale);

/** 全局 i18n（Composition API 模式） */
export const i18n = createI18n({
  legacy: false,
  locale: initialLocale,
  fallbackLocale: FALLBACK_LOCALE,
  messages: LOCALE_MESSAGES,
});

/** 切换语言并持久化 */
export function setI18nLocale(locale) {
  if (!SUPPORTED_LOCALES.some((item) => item.value === locale)) return;
  if (i18n.global.locale.value === locale) return;

  try {
    localStorage.setItem(LOCALE_STORAGE_KEY, locale);
  } catch {
    /* ignore */
  }

  i18n.global.locale.value = locale;
  applyHtmlLang(locale);
}
